import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject, throwError, BehaviorSubject, Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { map, catchError } from 'rxjs/operators';
import { URLS } from '../constants/URLS';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ApiService } from './api.service';
import { WhiteLabelService } from './white-label.service';
import { GuestTokenService } from './guest-token.service';

declare let shaka: any | undefined;
declare var window: any | undefined;

@Injectable({
  providedIn: 'root'
})

export class AuthenticateserviceService {
  
  error = new Subject<string>();
  private successMessage: string = '';

  constructor(
    private http: HttpClient,
    private router: Router,
    private snackBar: MatSnackBar,
    private universalApi: ApiService,
    private whitelabelService: WhiteLabelService,
    private guestTokenService: GuestTokenService
  ) {
    window.addEventListener('online', this.updateOnlineStatus.bind(this));
    window.addEventListener('offline', this.updateOnlineStatus.bind(this));
  }

  // Update these methods in your AuthenticateService to store BOTH tokens:

generateJwtToken(token) {
  console.log("input-->");
  console.log("input-->" + token);
  
  const requestBody = {
    "mobile": "1234",
    "fb_token": token
  };

  return this.universalApi.post(URLS.getJwtToken, requestBody).pipe(
    map(responseData => {
      console.log(JSON.stringify(responseData));
      if (responseData.responseCode == 200 && responseData.data && responseData.token) {
        console.log("server response=" + JSON.stringify(responseData));

        localStorage.setItem("token", responseData.token)
        localStorage.setItem("refreshToken", responseData.refreshToken);
        
        localStorage.setItem("userName", responseData.data.screenName);
        localStorage.setItem("userId", responseData.data.localUserId);
        localStorage.setItem("profileImage", responseData.data.profileImage);
        return responseData.data;
      } else {
        return undefined;
      }
    }),
    catchError(errorRes => {
      return throwError(errorRes);
    })
  );
}

registerNewUser(requestBody) {
  return this.universalApi.post(URLS.createUser, requestBody).pipe(
    map(responseData => {
      console.log("new user registration API response", JSON.stringify(responseData));
      if (responseData.responseCode == 200) {
        return responseData;
      } else {
        console.log("no result for new user registration");
        return undefined;
      }
    }),
    catchError(errorRes => {
      console.log("inside catch block for register user", errorRes);
      return throwError(errorRes);
    })
  );
}

toqqerUserLogin(idToken: string) {
  const requestBody = {
    "tqrIdToken": idToken
  };
  return this.universalApi.post(URLS.userLogin, requestBody).pipe(
    map(responseData => {
      console.log('User login response:', responseData);
      if (responseData.responseCode == 200 && responseData.refreshToken) {
        // Store BOTH tokens
        localStorage.setItem('token', responseData.refreshToken);
        // localStorage.setItem('refreshToken', responseData.refreshToken); 
        // Store user data if available
        if (responseData.data) {
          localStorage.setItem('userName', responseData.data.screenName || '');
          localStorage.setItem('userId', responseData.data.localUserId || '');
          localStorage.setItem('profileImage', responseData.data.profileImage || '');
        }
        
        return responseData;
      } else {
        throw new Error('Login failed');
      }
    }),
    catchError(errorRes => {
      return throwError(errorRes);
    })
  );
}

toqqerGetRefreshToken(idToken: string) {
  const requestBody = {
    "tqrIdToken": idToken
  };
  return this.universalApi.post(URLS.authenticate, requestBody).pipe(
    map(responseData => {
      console.log('Get refresh token response:', responseData);
      if (responseData.responseCode == 200 && responseData.refreshToken) {
        // Store BOTH tokens
        localStorage.setItem('token', responseData.refreshToken);
        localStorage.setItem('refreshToken', responseData.refreshToken); // ADD THIS LINE
        
        return responseData;
      } else {
        throw new Error('Refresh token failed');
      }
    }),
    catchError(errorRes => {
      return throwError(errorRes);
    })
  );
}

  updateUser(requestBody) {
    return this.universalApi.post(URLS.updateUser, requestBody).pipe(
      map(responseData => {
        console.log('profile updated successfully', JSON.stringify(responseData));
        return responseData;
      }),
      catchError((err) => {
        console.log('something went wrong', JSON.stringify(err));
        return throwError(err);
      })
    );
  }

  uploadUserProfileImage(requestBody) {
    return this.http.post<any>(URLS.uploadProfileImage, requestBody).pipe(
      map(responseData => {
        console.log("profile image upload API response", JSON.stringify(responseData));
        if (responseData.message == "success") {
          return responseData;
        } else {
          console.log("no result for profile image upload");
          return undefined;
        }
      }),
      catchError(errorRes => {
        console.log("inside catch block for profile image upload", errorRes);
        return throwError(errorRes);
      })
    );
  }

  calculateModifiedDate(createdAt: string): string {
    const createdDate = new Date(createdAt);
    const currentDate = new Date();
    if (
      createdDate.getDate() === currentDate.getDate() &&
      createdDate.getMonth() === currentDate.getMonth() &&
      createdDate.getFullYear() === currentDate.getFullYear()
    ) {
      return 'Today';
    }
    const yesterday = new Date(currentDate);
    yesterday.setDate(currentDate.getDate() - 1);
    if (
      createdDate.getDate() === yesterday.getDate() &&
      createdDate.getMonth() === yesterday.getMonth() &&
      createdDate.getFullYear() === yesterday.getFullYear()
    ) {
      return 'Yesterday';
    }
    const timeDifference = currentDate.getTime() - createdDate.getTime();
    const daysDifference = Math.floor(timeDifference / (1000 * 3600 * 24));
    if (daysDifference < 30) {
      return `${daysDifference} days ago`;
    } else if (daysDifference < 365) {
      const monthsDifference = Math.floor(daysDifference / 30);
      return `${monthsDifference} months ago`;
    } else {
      const yearsDifference = Math.floor(daysDifference / 365);
      return `${yearsDifference} years ago`;
    }
  }

  discoverAuthMethods(channelId: string, phoneNumber: string) {
    const url = `${URLS.authMethods}?channelId=${channelId}&phoneNumber=${phoneNumber}`;
    return this.universalApi.get(url);
  }

  toqqerSignInWithPhoneNumber(identifier: any, countryCode: any, deviceId: any, authMethod?: string) {
    const requestBody: any = {
      identifier: `${countryCode}${identifier}`,
      identifierType: 'PHONE',
      deviceId,
      deviceType: 'WEB',
      companyId: this.whitelabelService.isWhiteLabelMode ? localStorage.getItem('wl_content_provider_id') || '1' : '1'
    };
    if (authMethod) {
      requestBody.authMethod = authMethod;
    }

    return this.universalApi.post(URLS.verifyPhonenumber, requestBody);
  }

  toqqerSignInWithEmail(email: string, deviceId:string){
    const requestBody = {
      "identifier": email,
      "identifierType": "EMAIL",
      deviceId: deviceId,
      deviceType: 'WEB'
    }
    return this.universalApi.post(URLS.verifyPhonenumber, requestBody);
  }

  toqqerVerifyOtp(otp: string, verifyId: string, deviceId: any) {
    const requestBody = {
      "otp": otp,
      "verificationId": verifyId,
    };
    return this.universalApi.post(URLS.verifyOtp, requestBody);
  }

  showNotification(message: string) {
    const config = new MatSnackBarConfig();
    config.duration = 3000;
    config.horizontalPosition = 'center';
    config.verticalPosition = 'bottom';
    config.panelClass = ['custom-notification'];
    this.snackBar.open(message, 'X', config);
  }

  getSuccessMessage(): string {
    return this.successMessage;
  }

  setSuccessMessage(message: string): void {
    this.successMessage = message;
  }

  public isAuthenticatedSubject = new BehaviorSubject<boolean>(this.hasValidToken());
  public isAuthenticated$ = this.isAuthenticatedSubject.asObservable();

  private hasValidToken(): boolean {
    return !!localStorage.getItem('token') || !!localStorage.getItem('guestToken');
  }

  public isGuest(): boolean {
    return this.guestTokenService.isGuest;
  }

  public isAuthenticated(): boolean {
    return this.isAuthenticatedSubject.value;
  }

  async logout() {
    try {
      const requestBody = {
        refreshToken: localStorage.getItem('refreshToken')
      };
      await this.http.post(URLS.logout, requestBody).toPromise();
      this.clientLogout();
      if (!this.isIOSWKWebView() && (window as any).storage) {
        const content = await (window as any).storage.list();
        for (const video of content) {
          await this.removeFromDB(video);
        }
        await (window as any).storage.destroy();
      }
    } catch (error) {
      console.error("Error during logout:", error);
      this.clientLogout();
    }
  }

  clientLogout(){
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    this.guestTokenService.clearGuestState();
    localStorage.removeItem('screenName');
    localStorage.removeItem('category');
    localStorage.removeItem('contact');
    localStorage.removeItem('userId');
    localStorage.removeItem('profileImage');
    localStorage.removeItem('description');
    localStorage.removeItem('appDarkMode');
    localStorage.removeItem('userName');
    // NOTE: deviceId is intentionally NOT removed — it's a stable per-device
    // fingerprint now, and wiping it would mint a new id next login → device-row
    // churn (the very thing that was breaking sessions).
    // localStorage.removeItem('toqqer_axinom_fp_url');
    // localStorage.removeItem('toqqer_axinom_token');
    // localStorage.removeItem('toqqer_axinom_wv_url');
    // localStorage.removeItem('drm_persistent_session');
    sessionStorage.clear();
    this.isAuthenticatedSubject.next(false);
    const route = this.whitelabelService.getPrefixedRoute('login');
    this.router.navigate([route], { replaceUrl: true });
  }
  
  async removeFromDB(video) {
    try {
      if(video.offlineUri) {
        if(video.drmSession) {
          await this.closeDRMSession(video.drmSession);
          console.log(`DRM session closed for video: ${video.title}`);
        }
        if(window.storage) {
          await window.storage.remove(video.offlineUri);
          console.log(`Removed video: ${video.title}`);
        }
      } else {
        console.warn('No offlineUri found for video:', video);
      }
    } catch(error) {
      console.error('Error while removing video from DB', error);
    }
  }

  async closeDRMSession(drmSession) {
    try {
      if(drmSession) {
        await drmSession.close();
        console.log('DRM session closed.');
      } else {
        console.log('No DRM session to close.');
      }
    } catch(error) {
      console.error('Failed to close DRM session:', error);
    }
  }

  private isIOSWKWebView(): boolean {
    const ua = window.navigator.userAgent;
    const isIOS = /iPad|iPhone|iPod/.test(ua);
    const isWebKit = /WebKit/.test(ua) && !/CriOS/.test(ua);
    return isIOS && isWebKit;
  }

  private onlineStatus = new BehaviorSubject<boolean>(navigator.onLine);

  get isOnline(): Observable<boolean> {
    return this.onlineStatus.asObservable();
  }

  private updateOnlineStatus() {
    this.onlineStatus.next(navigator.onLine);
  }
}